const LinkDownIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props}
	>
		<path d="M8 11L3 11L3 6" strokeWidth="2" />
		<path d="M9 10.5L11.5 10.5L11.5 2.5L3.5 2.5L3.5 5" />
		<path d="M3.5 10.5L8 6" strokeWidth="2" />
	</svg>
)

export default LinkDownIcon